function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_196",
  "data-name": "Group 196",
  transform: "translate(-359.148 -824.397)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_101",
  "data-name": "Path 101",
  d: "M381.225,841.8H361.317a1.3,1.3,0,0,1-1.286-1.286V826.433a1.3,1.3,0,0,1,1.286-1.286h19.909a1.3,1.3,0,0,1,1.286,1.286V840.5A1.277,1.277,0,0,1,381.225,841.8Z",
  transform: "translate(-0.133)",
  fill: "none",
  stroke: "#f65e5c",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_21",
  "data-name": "Line 21",
  x2: 22.402,
  transform: "translate(359.975 845.153)",
  fill: "none",
  stroke: "#f65e5c",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_102",
  "data-name": "Path 102",
  d: "M360.031,924.775",
  transform: "translate(-0.133 -86.908)",
  fill: "none",
  stroke: "#f65e5c",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3",
  "data-name": "Ellipse 3",
  cx: 2.532,
  cy: 2.532,
  r: 2.532,
  transform: "translate(374.099 827.738)",
  fill: "none",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_103",
  "data-name": "Path 103",
  d: "M359.878,898.223l3.409-3.409,1.948,1.948,5.552-5.552,8.084,8.084",
  transform: "translate(0 -57.628)",
  fill: "none",
  stroke: "#f65e5c",
  strokeWidth: 1.5
}));

var SvgExh = function SvgExh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.981,
    height: 21.506,
    viewBox: "0 0 23.981 21.506",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exh.cef63f77.svg";
export { ForwardRef as ReactComponent };